module.exports = __webpack_public_path__ + "img/public/AdminIcons/default.svg?dd39042a";